var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4506 20.3145L9.8153 9.6792C9.56432 9.93018 9.41138 10.3341 9.41138 10.8753V29.7576C9.41138 30.2792 9.56432 30.6988 9.8153 30.9537L20.4506 20.3184V20.3145Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8969 23.9144L30.0851 21.5418C31.2812 20.8673 31.2812 19.7575 30.0851 19.083L25.8969 16.7104L22.2969 20.3104L25.8969 23.9104V23.9144Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8621 31.7849C11.2503 32.1536 11.8699 32.1889 12.5601 31.7849L24.964 24.7496L21.4307 21.2163L10.8621 31.7849Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.964 15.8756L12.5601 8.82464C11.8699 8.43641 11.2464 8.4717 10.8621 8.84033L21.4307 19.409L24.964 15.8756Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.199219 0.314453V40.3144H40.1992V0.314453H0.199219ZM39.4149 39.5301H0.983532V1.09877H39.4149V39.5301Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialGoogle);
export default __webpack_public_path__ + "static/media/social_google.d445ccd037f78df08d092b2a28fafaa4.svg";
export { ForwardRef as ReactComponent };